/**
 * Calculate cover/contain of images
 */

function fitFactory(contains, fraction) {
  return function (containerWidth, containerHeight, width, height) {
    var doRatio = width / height;
    var cRatio = containerWidth / containerHeight;
    var targetWidth = 0;
    var targetHeight = 0;
    var test = contains ? (doRatio > cRatio) : (doRatio < cRatio);

    if (test) {
      targetWidth = containerWidth;
      targetHeight = targetWidth / doRatio;
    } else {
      targetHeight = containerHeight;
      targetWidth = targetHeight * doRatio;
    }

    if (fraction) {
      return {
        width: targetWidth / containerWidth,
        height: targetHeight / containerHeight,
        x: ((containerWidth - targetWidth) / 2) / containerWidth,
        y: ((containerHeight - targetHeight) / 2) / containerHeight
      };
    } else {
      return {
        width: targetWidth,
        height: targetHeight,
        x: (containerWidth - targetWidth) / 2,
        y: (containerHeight - targetHeight) / 2
      };
    }
  }
}

export const cover = fitFactory(false, true)
